const swiperX = new Swiper('.info-slider', {
   slidesPerView: 1.2,
  spaceBetween: 20,
  centeredSlides: true,
  freeMode: false,
  infinite : true,
  loop: true,
  // speed : 700,
 //  autoplay: {
 //   delay: 5000,
    
 //   disableOnInteraction: false,
 // },
  mousewheel: {
    forceToAxis: true,
    invert: true,
  },
  keyboard: { enabled: true },
  navigation: {
    nextEl: ".swiper-button-next-ann",
    prevEl: ".swiper-button-prev-ann"
  },

});

const swiperY = new Swiper('.info-slider-2', {
   slidesPerView: "auto",
  spaceBetween: 20,
  centeredSlides: true,
  freeMode: false,
  loop: true,
  // speed : 700,
 //  autoplay: {
 //   delay: 5000,
    
 //   disableOnInteraction: false,
 // },
  mousewheel: {
    forceToAxis: true,
    invert: true,
  },
  keyboard: { enabled: true },
  navigation: {
    nextEl: ".swiper-button-next-ann",
    prevEl: ".swiper-button-prev-ann"
  },
 breakpoints: {

    768: {
      slidesPerView: 1.3,
      spaceBetween: 20,
    }
  }
});

 const openBtn = document.getElementById('com-popup-open');
const popup = document.querySelector('.com-popup-main');
const overlay = document.querySelector('.com-popup-overlay');
const closeBtn = document.querySelector('.close-com-popup');
const headerWrap = document.querySelector('.shopify-section--header');

function openPopup() {
  headerWrap.style.opacity = 0;
  headerWrap.style.transform = 'translateY(-100px)';
  popup.classList.add('active');
  if (overlay) overlay.classList.add('active');
}

function closePopup() {
  headerWrap.style.opacity = 1;
  headerWrap.style.transform = 'translateY(0)';
  popup.classList.remove('active');
  if (overlay) overlay.classList.remove('active');
}

openBtn.addEventListener('click', openPopup);
closeBtn.addEventListener('click', closePopup);
if (overlay) overlay.addEventListener('click', closePopup);
